import { useTheme } from "next-themes";
import { ToastContainer } from "react-toastify";

export const ToastWrapper = () => {
  const { resolvedTheme } = useTheme();

  return (
    <ToastContainer
      position="top-left"
      theme={resolvedTheme === "dark" ? "dark" : "light"}
    />
  );
};
